import { normalizedAudioVoiceId } from "./audio-voice-policy.mjs";

const DEVICE_SPEECH_FORMAT = "device-speech";
const MP3_FORMAT = "mp3";
const AUDIO_VOICE_SELECTION_CONTRACT_VERSION = 1;

function trimmedString(value) {
  return typeof value === "string" ? value.trim() : "";
}

/**
 * Mirrors Android's strict response resolver. Automatic narration remains
 * compatible with legacy MP3 responses, while explicit narrators must be
 * attested and device speech must be an exact, capability-authorized envelope.
 */
export function resolveCanonicalAudioResponse(
  response,
  { requestedVoiceId, deviceSpeechAuthorized = false } = {},
) {
  const value = response && typeof response === "object" ? response : {};
  const requested = normalizedAudioVoiceId(requestedVoiceId);
  const explicitNarrator = requested !== "auto";

  if (value.format === DEVICE_SPEECH_FORMAT) {
    if (explicitNarrator) return Object.freeze({ kind: "selected-narrator-unavailable" });
    const speechText = trimmedString(value.speechText);
    const audioContentIsBlank =
      value.audioContent == null ||
      (typeof value.audioContent === "string" && !value.audioContent.trim());
    const exactEnvelope =
      deviceSpeechAuthorized === true &&
      value.ok === true &&
      value.cache === DEVICE_SPEECH_FORMAT &&
      audioContentIsBlank &&
      Boolean(speechText);
    return exactEnvelope
      ? Object.freeze({ kind: "device-speech", speechText })
      : Object.freeze({ kind: "invalid-device-speech" });
  }

  const audioContent = trimmedString(value.audioContent);
  const format = trimmedString(value.format);
  if ((format && format !== MP3_FORMAT) || !audioContent) {
    return Object.freeze({ kind: "empty-audio" });
  }
  if (!explicitNarrator) return Object.freeze({ kind: "mp3", audioContent });

  const attested =
    trimmedString(value.requestedVoiceId).toLowerCase() === requested &&
    trimmedString(value.effectiveVoiceId).toLowerCase() === requested &&
    value.voiceSelectionApplied === true &&
    Number.isInteger(value.audioVoiceSelectionVersion) &&
    value.audioVoiceSelectionVersion >= AUDIO_VOICE_SELECTION_CONTRACT_VERSION;
  return attested
    ? Object.freeze({ kind: "mp3", audioContent })
    : Object.freeze({ kind: "selected-narrator-unavailable" });
}
